import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Checkbox, Radiogroup, Select } from "../form";
import { Slider } from "../slider";
/**
 * Produce an array of Select elements based on parameter instances from the Map Tile API. The structure
 * provided by the API is recursively nested.
 */
const createParameterElements = (elements, layerItem, instances, onParameterChange) => {
    const definitions = layerItem.parameterDefinitions;
    const values = layerItem.options;
    const instance = instances[0];
    const definition = definitions.find((d) => d.id === instance.definitionId);
    if (!definition) {
        return elements;
    }
    let selectedInstance = instances.find(({ values }) => values[0].value === instance.default);
    if (values.has(definition.id)) {
        const preferredInstance = instances.find(({ values: instanceValues }) => instanceValues[0].value === values.get(definition.id));
        if (preferredInstance !== undefined) {
            selectedInstance = preferredInstance;
        }
    }
    if (selectedInstance === undefined) {
        selectedInstance = instances[0];
    }
    if (instances.length > 1) {
        elements.push(_jsx(Select, { id: `select-${definition.id}`, testId: `select-${definition.id}`, options: instances.map(({ values }) => {
                const value = values[0].value.toString(); // multiple values not currently supported
                return {
                    value,
                    label: value,
                };
            }), label: definition.label, name: definition.id, onChange: (e) => {
                const value = e.target.value;
                const valueAsNumber = e.target.valueAsNumber;
                onParameterChange &&
                    onParameterChange(layerItem.id, definition.id, isNaN(valueAsNumber) ? value : valueAsNumber);
            }, selected: selectedInstance.values[0].value.toString(), height: "sm" }));
    }
    if (selectedInstance.values[0].instances) {
        createParameterElements(elements, layerItem, selectedInstance.values[0].instances, onParameterChange);
    }
    return elements;
};
export const LayerOptions = ({ layerItems, layerItem, categoryFilters, onOpacityChange, onOptionChange, onFilterChange, }) => {
    var _a;
    const parameterElements = useMemo(() => {
        if (layerItem.parameterInstances) {
            return createParameterElements([], layerItem, layerItem.parameterInstances, onOptionChange);
        }
    }, [layerItems]);
    return (_jsxs("div", { className: "border-light dark:border-dark-light mt-2 border-b-2 border-t-2 px-2 pb-4 pt-2", children: [_jsx(Slider, { id: `opacity-${layerItem.id}`, label: "Opacity", value: (_a = layerItem.options.get("opacity")) !== null && _a !== void 0 ? _a : 1, onChange: (value) => {
                    onOpacityChange && onOpacityChange(layerItem.id, value);
                    onOptionChange &&
                        onOptionChange(layerItem.id, "opacity", value);
                }, min: 0, max: 1, step: 0.1 }), layerItem.styles && layerItem.styles.length > 1 && (_jsx("div", { className: "mt-4", children: _jsx(Radiogroup, { id: `radiogroup-${layerItem.id}-style`, testId: `radiogroup-${layerItem.id}-style`, group: `${layerItem.id}-style`, label: "", selected: layerItem.options.get("style-id") || "default", onChange: (e) => {
                        const value = e.target.value;
                        onOptionChange && onOptionChange(layerItem.id, "style-id", value);
                    }, children: layerItem.styles.map((s) => (_jsx(Radiogroup.Radio, { value: s.id, label: s.label }, s.id))) }) })), categoryFilters && categoryFilters.length && (_jsx("div", { className: "bg-components-lighter dark:bg-dark-components-lighter mt-4 rounded-md pb-4 pl-2", children: Object.keys(categoryFilters).map((categoryLabel) => {
                    return (_jsxs("div", { children: [_jsx("div", { className: "text-tertiary dark:text-dark-tertiary flex py-2", id: categoryLabel, children: _jsx("div", { className: "flex-auto", children: categoryLabel }) }), Object.values(categoryFilters[categoryLabel]).map((f) => {
                                const checked = layerItem.options.has("filters") &&
                                    layerItem.options.get("filters").has(f.id);
                                return (_jsx("div", { className: "py-1", children: _jsx(Checkbox, { id: `${layerItem.id}-${f.id}-checkbox`, label: f.label, value: f.id, checked: checked, onChange: (e) => {
                                            onFilterChange &&
                                                onFilterChange(layerItem.id, f.id, e.target.checked);
                                        } }) }, `filter-${layerItem.id}-${f.id}`));
                            })] }, `filter-category-${categoryLabel}`));
                }) })), parameterElements && (_jsx("div", { className: "mt-2", children: parameterElements.map((element, index) => {
                    return (_jsx("div", { className: "pt-2", children: element }, `parameter-${layerItem.id}-parameter-${index}`));
                }) })), _jsx("div", { className: "mt-2", children: layerItem.customLayerOptions })] }));
};
